<template>
  <div class="eval-report-page">
    <eval-report
      v-if="evaluation"
      :evaluation="evaluation"
      :evaluation-id="evaluationId"
      @on-back="$router.push({ name: 'evaluation_list' })"
    />
  </div>
</template>

<script>
import EvaluationApi from 'dashboard/api/evaluations.js';
import EvalReport from './EvalReport.vue';

export default {
  components: { EvalReport },
  data() {
    return {
      evaluation: null,
    };
  },
  computed: {
    evaluationId() {
      return Number(this.$route.params.id);
    },
  },
  async created() {
    try {
      const res = await EvaluationApi.getEvaluationsList();
      const list = res.data.data || [];
      this.evaluation = list.find(e => e.id === this.evaluationId) || null;
    } catch {
      // evaluation stays null
    }
  },
};
</script>

<style scoped lang="scss">
.eval-report-page {
  background: white;
  min-height: 100%;
}

.page-back {
  padding: var(--space-normal) var(--space-normal) 0;
}
</style>
